import * as React from "react";

// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

/* eslint-disable */

import { Icon, Message } from "semantic-ui-react";
import * as i18n from "../../config/i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Default = () => /*#__PURE__*/_jsxs(Message, {
  info: true,
  icon: true,
  style: {
    height: "100%"
  },
  "data-sentry-element": "Message",
  "data-sentry-component": "Default",
  "data-sentry-source-file": "Default.tsx",
  children: [/*#__PURE__*/_jsx(Icon, {
    name: "search",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "Default.tsx"
  }), /*#__PURE__*/_jsxs(Message.Content, {
    "data-sentry-element": "unknown",
    "data-sentry-source-file": "Default.tsx",
    children: [/*#__PURE__*/_jsx(Message.Header, {
      "data-sentry-element": "unknown",
      "data-sentry-source-file": "Default.tsx",
      children: i18n.errorHeader
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx("span", {
        children: i18n.errorMessage
      })
    })]
  })]
});
export default Default;